import { defineMessages } from 'react-intl';

const messages: {
	addCardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	removeCardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	workSource: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sourceTypeLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	workItemsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	removeButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	addCardTitle: {
		id: 'conversation-assistant-message-actions.work-source.add-card-title',
		defaultMessage: 'Add plan work source',
		description: 'Title for the add work source action card',
	},
	removeCardTitle: {
		id: 'conversation-assistant-message-actions.work-source.remove-card-title',
		defaultMessage: 'Remove plan work source',
		description: 'Title for the remove work source action card',
	},
	workSource: {
		id: 'conversation-assistant-message-actions.work-source.work-source',
		defaultMessage: 'Work source',
		description: 'Fallback title when work source name is not available',
	},
	sourceTypeLabel: {
		id: 'conversation-assistant-message-actions.work-source.source-type-label',
		defaultMessage: 'Source type',
		description:
			'Text shown as a field label for the source type (e.g. board, project, filter) in the update plan work source action card in Rovo chat.',
	},
	workItemsLabel: {
		id: 'conversation-assistant-message-actions.work-source.work-items-label',
		defaultMessage: 'Work items',
		description:
			'Text shown as a field label displaying the number of work items associated with a work source in the update plan work source action card in Rovo chat.',
	},
	addButton: {
		id: 'conversation-assistant-message-actions.work-source.add-button',
		defaultMessage: 'Add',
		description:
			'Text shown on a primary button in the add plan work source action card in Rovo chat that confirms adding the selected work source to the plan.',
	},
	removeButton: {
		id: 'conversation-assistant-message-actions.work-source.remove-button',
		defaultMessage: 'Remove',
		description:
			'Text shown on a primary button in the remove plan work source action card in Rovo chat that confirms removing the selected work source from the plan.',
	},
	cancelButton: {
		id: 'conversation-assistant-message-actions.work-source.cancel-button',
		defaultMessage: 'Cancel',
		description:
			'Text shown on a button in the update plan work source action card in Rovo chat that discards the operation and closes the card.',
	},
});

export default messages;
